import { Button, Divider, Grid } from "@material-ui/core";
import React, { useEffect } from "react";
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { CalendarToday as CalendarTodayIcon } from "@material-ui/icons";
import ReactDatePicker from "react-datepicker";

import "./style.css";
import { isEmpty, isFunction } from "lodash";
import moment from "moment";

const InnerPicker = () => {
  return <input />;
};

const DatePickerAtom = ({ label, onChange, value = null }) => {
  const [selectedDate, setSelectedDate] = React.useState(null);

  useEffect(() => {
    setSelectedDate(
      isEmpty(value) ? null : new Date(moment(value).toISOString())
    );
  }, [value]);

  return (
    <Grid container direction="row" className="date-picker-atom">
      <Button
        variant="contained"
        size="medium"
        className="outer-action-button"
        startIcon={<CalendarTodayIcon />}
      >
        {label}
      </Button>
      <Divider orientation="vertical" />
      <ReactDatePicker
        selected={selectedDate}
        onChange={(date) => {
          if (isFunction(onChange)) {
            const output = moment(date).format("YYYY-MM-DD");
            onChange(output);
          }
        }}
        className="inner-picker-input"
        customTimeInput={<InnerPicker />}
        dateFormat="yyyy-MM-dd"
      />
    </Grid>
  );
};

export default DatePickerAtom;
